const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/initialValues.ts';
import { usePatientData } from 'App/store/patient';
import { useSelector } from 'react-redux';
import { selectUserDetailsFromRegisterWorkItem } from 'App/store/login';
import { selectRelationTypes } from 'App/store/metaKat';
import { useRelatives } from 'App/store/relative';
import { normalizePhoneNumber } from 'App/utils/phoneNumberUtils';
import { getArztDataFromCase } from 'App/utils/cases';
import { useCaseData } from 'App/store/case';
import { findRelationKey } from 'App/utils/person';
import _ from 'lodash';

export const useECheckinInitialValues = (fallNr?: string) => {
    const [pat, patientIsLoading] = usePatientData();
    const loginDetails = useSelector(selectUserDetailsFromRegisterWorkItem);
    const [caseData, caseDataIsLoading] = fallNr ? useCaseData(fallNr) : [undefined, false];
    const hausArztData = getArztDataFromCase(caseData, 'HausAz');
    const relationTypes = useSelector(selectRelationTypes);
    const { data: referencePersons, isPendingOrLoading: isRelativesLoading } = fallNr
        ? useRelatives(fallNr)
        : { data: undefined, isPendingOrLoading: false };

    const isLoading = patientIsLoading || caseDataIsLoading || isRelativesLoading;

    const persAngaben = {
        firstname: pat.get('VORNAME') ?? loginDetails?.get('firstname') ?? '',
        lastname: pat.get('NAME') ?? loginDetails?.get('lastname') ?? '',
        streetAndNumber: pat.get('STRASSE') ?? '',
        plz: pat.get('PLZ') ?? '',
        ort: pat.get('ORT') ?? '',
        country: pat.get('LAND') ?? '',
        gender: pat.get('SEX') ?? '',
        dateOfBirth: (pat.get('GEBDAT') || '').slice(0, 10), // YYYY-MM-DD
        tel: normalizePhoneNumber(pat.get('TELEFON') || pat.get('TELEFON_G')) || '',
        mobile: normalizePhoneNumber(pat.get('TELEFON_M') ?? loginDetails?.get('mobile')) ?? '',
        nationality: pat.get('NATIONALITAET') ?? '',
        zivilstand: pat.get('ZIVILSTAND') ?? '',
        lang: pat.get('SPRACHE') ?? '',
        ahv: pat.get('SOZVERSNR') ?? '',
        religion: pat.get('KONFESSION') ?? '',
        profession: pat.get('BERUF') ?? '',
        hometown: pat.get('HEIMATORT') ?? '',
        email: loginDetails?.get('email') ?? '',
    };

    const relatives = _.compact(referencePersons);
    let contact = {};
    if (relatives && relatives.length > 0 && !isRelativesLoading) {
        if (relatives.length >= 2) {
            contact = {
                beziehung: findRelationKey(relationTypes, relatives[0].VERWANDSCHAFTSGRAD),
                firstname: relatives[0].VORNAME,
                lastname: relatives[0].NAME,
                tel: normalizePhoneNumber(relatives[0].TEL),
                email: relatives[0].EMAIL,
                streetAndNumber: relatives[0].STRASSE,
                ort: relatives[0].ORT,
                plz: relatives[0].PLZ,
                country: relatives[0].LAND,

                secondbeziehung: findRelationKey(relationTypes, relatives[1].VERWANDSCHAFTSGRAD),
                secondfirstname: relatives[1].VORNAME,
                secondlastname: relatives[1].NAME,
                secondtel: normalizePhoneNumber(relatives[1].TEL),
                secondemail: relatives[1].EMAIL,
                secondstreetAndNumber: relatives[1].STRASSE,
                secondort: relatives[1].ORT,
                secondplz: relatives[1].PLZ,
                secondcountry: relatives[1].LAND,
            };
        } else {
            contact = {
                beziehung: findRelationKey(relationTypes, relatives[0].VERWANDSCHAFTSGRAD),
                firstname: relatives[0].VORNAME,
                lastname: relatives[0].NAME,
                tel: normalizePhoneNumber(relatives[0].TEL),
                email: relatives[0].EMAIL,
                streetAndNumber: relatives[0].STRASSE,
                ort: relatives[0].ORT,
                plz: relatives[0].PLZ,
                country: relatives[0].LAND,
            };
        }
    }
    const einwArzt = hausArztData
        ? {
              key: hausArztData.OBJECTKEY,
              firstname: hausArztData.Vorname,
              lastname: hausArztData.Name,
              ort: hausArztData.Ort,
              country: hausArztData.Land,
              streetAndNumber: hausArztData.Strasse,
              plz: hausArztData.PLZ,
          }
        : {};

    return [{ persAngaben, contact, einwArzt }, isLoading];
};
